<template>
  <nav :class="{sidebar: true, sidebarStatic, sidebarOpened}">
    <header class="logo">
      <!--<router-link to="/app/"><span class="text-warning">Teamio</span></router-link>-->
      <img  src="../../assets/logo-teamio.png" alt="..." width="40"/>
    </header>
    <ul class="nav">
      
      <!--
      <NavLink
        :activeItem="activeItem"
        header="Dashboard"
        link="/app/task-list/overdue-recall"
        iconName="flaticon-home"
        index="main"
        isHeader
        id="dashboard"
      />
      <b-tooltip class="tool_tip" target="dashboard" placement="left" triggers="hover">Dashboard</b-tooltip>
      -->

      <NavLink
        v-if="$can('view', 'practice-pulse')"
        :activeItem="activeItem"        
        link="/app/practice-pulse"
        iconName="fa-dashboard"
        index="practice-pulse"
        isHeader
        id="PracticePulse"
      />
      <b-tooltip v-if="elementExists('PracticePulse')" target="PracticePulse" custom-class="tool_tip" placement="left" container="wrap" triggers="hover">Practice Ops</b-tooltip>

      <NavLink
        :activeItem="activeItem"        
        link="/app/admin"
        iconName="fa-home"
        index="admin"
        isHeader
        id="Admin"
      />
      <b-tooltip target="Admin" custom-class="tool_tip" placement="left" container="wrap" triggers="hover">Today's Dashboard</b-tooltip>

      <!--
        Schedule - Chart Audit (Schedule View). Shown when the CASL subject 'schedule' allows it
        (config/ability.js): a Super Admin always, everyone but Outsourced when the office's switch is
        on AND its Teamio app is 3.0.61+. v-if, not v-show — an office without it has no icon in the
        DOM. Same rule as the route's meta.requires (src/Routes.js) and NAV_APPS (utils/nav/apps.js).
        Plan: docs/plans/2026-10-28-schedule-chart-audit-release-plan.md
      -->
      <NavLink
        v-if="$can('view', 'schedule')"
        :activeItem="activeItem"
        link="/app/schedule"
        iconName="fa-calendar-o"
        index="schedule"
        isHeader
        id="ScheduleView"
      />
      <b-tooltip v-if="$can('view', 'schedule') && elementExists('ScheduleView')" target="ScheduleView" custom-class="tool_tip" placement="left" container="wrap" triggers="hover">Schedule - Chart Audit</b-tooltip>

      <NavLink
        v-if="$can('view', 'apt-reminder')"
        :activeItem="activeItem"
        link="/app/apt-reminder"
        iconName="fa-calendar-check-o"
        index="apt-reminder"
        isHeader
        id="AptReminder"
      />
      <b-tooltip v-if="elementExists('AptReminder')" target="AptReminder" custom-class="tool_tip" placement="left" container="wrap" triggers="hover">Appointment Reminders</b-tooltip>

      <NavLink
        v-if="$can('view', 'huddle')"
        :activeItem="activeItem"
        link="/app/huddle"
        iconName="fa-group"
        index="huddle"
        isHeader
        id="Huddle"
      />
      <b-tooltip v-if="elementExists('Huddle')" target="Huddle" custom-class="tool_tip" placement="left" container="wrap" triggers="hover">Today's Huddle</b-tooltip>

      <NavLink
        v-if="canAccessTxPresenter"
        :activeItem="activeItem"
        link="/app/tx-presenter"
        iconName="fa-stethoscope"
        index="tx-presenter"
        isHeader
        id="TxPresenter"
      />
      <b-tooltip v-if="canAccessTxPresenter && elementExists('TxPresenter')" target="TxPresenter" custom-class="tool_tip" placement="left" container="wrap" triggers="hover">Tx Presenter</b-tooltip>

      <NavLink
        v-if="showInsuranceVerificationNav"
        :activeItem="activeItem"
        link="/app/insurance-verification"
        iconName="fa-shield"
        index="insurance-verification"
        isHeader
        id="InsuranceVerification"
      />
      <b-tooltip v-if="showInsuranceVerificationNav && elementExists('InsuranceVerification')" target="InsuranceVerification" custom-class="tool_tip" placement="left" container="wrap" triggers="hover">Insurance Verification</b-tooltip>

      <NavLink
        v-if="$can('view', 'reviews')"
        :activeItem="activeItem"
        link="/app/reviews"
        iconName="fa-star"
        index="reviews"
        isHeader
        id="Reviews"
      />
      <b-tooltip v-if="elementExists('Reviews')" target="Reviews" custom-class="tool_tip" placement="left" container="wrap" triggers="hover">Reviews</b-tooltip>

      <NavLink
        v-if="$can('view', 'team-insights')"
        :activeItem="activeItem"
        header="Team Insights"
        link="/app/team-insights"
        iconName="fa-magic"
        index="team-insights"
        isHeader
        id="team-insights"
      />
      <b-tooltip v-if="elementExists('team-insights')" target="team-insights" custom-class="tool_tip" placement="left" triggers="hover">Team Insights</b-tooltip>

      <!--<NavLink
        :activeItem="activeItem"
        header="Reports"
        link="/app/reports"
        iconName="flaticon-notebook"
        index="reports"
        isHeader
        id="reports"
      />
      <b-tooltip custom-class="tool_tip" target="reports" placement="left" triggers="hover">Reports</b-tooltip>
      -->

      <!--
      <NavLink
        v-if="$can('view', 'kpi')"
        :activeItem="activeItem"
        header="Practice Insights"
        link="/app/kpi"
        iconName="fa-bar-chart-o"
        index="reports"
        isHeader
        id="practice-insights"
      />
      <b-tooltip v-if="$can('view', 'kpi')" custom-class="tool_tip" target="practice-insights" placement="left" triggers="hover">Practice Insights: KPIs</b-tooltip>
      -->
      
        <NavLink
          v-if="$can('view', 'tasks')"
          :activeItem="activeItem"
          header="My Tasks"
          link="/app/todo"
          iconName="fa-tasks"
          index="my-tasks"
          isHeader
          id="my-tasks"
        />
       
        <b-tooltip v-if="elementExists('my-tasks')" target="my-tasks" custom-class="tool_tip" placement="left" triggers="hover">My Tasks</b-tooltip>

        <NavLink
          v-if="$can('view', 'kanban')"
          :activeItem="activeItem"
          header="Kanban"
          link="/app/kanban"
          :iconSrc="require('@/assets/kanban.png')"
          index="mykanban"
          isHeader
          id="mykanban"
          :greendot="hasKanbanUnread"
          badge=" "
        />
       
        <b-tooltip v-if="elementExists('mykanban')" target="mykanban" custom-class="tool_tip" placement="left" triggers="hover">Kanban</b-tooltip>

      <NavLink
        v-if="$can('view', 'chat')"
          :activeItem="activeItem"
          header="Chat"          
          link="/app/chat"
          iconName="fa-comments"
          index="chat"
          isHeader
          id="chat"
          :greendot="newChatMessagesAvailable"
          badge=" "
        />
       
      <b-tooltip v-if="elementExists('chat')" target="chat" custom-class="tool_tip" placement="left" triggers="hover">Chat</b-tooltip>

      <NavLink
          v-if="$can('view', 'conversations')"
          :activeItem="activeItem"
          header="Chat"          
          link="/app/conversations"
          iconName="fa-mobile"
          index="smsconvo"
          isHeader
          id="smsconvo"          
          :greendot="newConversationMsgAvailable"
          badge=" "
        />
       
      <b-tooltip v-if="$can('view', 'conversations')" target="smsconvo" custom-class="tool_tip" placement="left" triggers="hover">SMS Conversations</b-tooltip>

       <NavLink
        v-if="$can('view', 'wiki')"
        :activeItem="activeItem"
        header="Wiki"
        link="/app/wiki"
        iconName="fa-wikipedia-w"
        index="wiki"
        isHeader
        id="Wiki"
      />
      <b-tooltip v-if="elementExists('Wiki')" target="Wiki" custom-class="tool_tip"  placement="left" triggers="hover">Wiki</b-tooltip>

      <!-- Old Workflow Builder - Hidden, replaced by new Workflow Builder
      <NavLink
        v-if="$can('view', 'workflow')"
        :activeItem="activeItem"
        header="Workflow"
        link="/app/workflow"
        iconName="fa-sitemap"
        index="workflow"
        isHeader
        id="Workflow"
      />
      <b-tooltip v-if="$can('view', 'workflow')" target="Workflow" custom-class="tool_tip"  placement="left" triggers="hover">Workflow Builder</b-tooltip>
      -->

      <NavLink
        v-if="$can('view', 'workflow')"
        :activeItem="activeItem"
        header="Workflow"
        link="/app/workflow2-list"
        iconName="fa-sitemap"
        index="workflow2"
        isHeader
        id="Workflow2"
      />
      <b-tooltip v-if="$can('view', 'workflow')" target="Workflow2" custom-class="tool_tip"  placement="left" triggers="hover">Workflow Builder</b-tooltip>

      <NavLink
        v-if="$can('view', 'forms')"
        :activeItem="activeItem"
        header="Forms"
        link="/app/forms"
        iconName="fa-wpforms"
        index="forms"
        isHeader
        id="Forms"
      />
      <b-tooltip v-if="$can('view', 'forms')" target="Forms" custom-class="tool_tip"  placement="left" triggers="hover">Forms</b-tooltip>      

      <NavLink
        v-if="$can('view', 'online-appointments')"
        :activeItem="activeItem"
        link="/app/online-appointments"
        iconName="fa-calendar"
        index="online-appointments"
        isHeader
        id="OnlineAppointments"
      />
      <b-tooltip v-if="$can('view', 'online-appointments')" target="OnlineAppointments" custom-class="tool_tip" placement="left" container="wrap" triggers="hover">Online Appointments</b-tooltip>

      <NavLink
        v-if="$can('view', 'campaigns')"
        :activeItem="activeItem"
        header="Campaigns"
        link="/app/campaigns"
        iconName="fa-bullhorn"
        index="campaigns"
        isHeader
        id="Campaigns"
      />
      <b-tooltip v-if="$can('view', 'campaigns')" target="Campaigns" custom-class="tool_tip" placement="left" triggers="hover">Campaigns</b-tooltip>

      <NavLink
          :activeItem="activeItem"          
          link="https://teamio.app/help"
          iconName="fa-question-circle"
          index="help"
          isHeader
          id="help"
          external          
        />
       
      <b-tooltip target="help" custom-class="tool_tip" placement="left" triggers="hover">Teamio How-To</b-tooltip>

      <!--

      <NavLink
        :activeItem="activeItem"
        header="What's New?"
        link="/app/whatsnew"
        iconName="fa-bullhorn"
        index="whats-new"
        isHeader
        id="whats-new"
      />
      <b-tooltip custom-class="tool_tip" target="whats-new" placement="left" triggers="hover">What's New?</b-tooltip>
      -->

      <!--
      <NavLink
        :activeItem="activeItem"
        header="Team Insights2"
        link="/app/team-insights2"
        iconName="flaticon-controls"
        index="team-insights2"
        isHeader
        id="team-insights2"
      />
      <b-tooltip custom-class="tool_tip" target="team-insights2" placement="left" triggers="hover">team Insights2</b-tooltip>

      <NavLink
        :activeItem="activeItem"
        header="Routine"
        link="/app/routine"
        iconName="flaticon-database-1"
        index="routine"
        isHeader
        id="Routine"
      />
      <b-tooltip custom-class="tool_tip" target="Routine" placement="left" triggers="hover">Routine</b-tooltip>

      <NavLink
        :activeItem="activeItem"
        header="Checklists"
        link="/app/checklists"
        iconName="flaticon-database-1"
        index="checklist"
        isHeader
        id="Checklists"
      />
      <b-tooltip custom-class="tool_tip" target="Checklists" placement="left" triggers="hover">Checklists</b-tooltip>
      -->

      

     <!--
      <NavLink
        :activeItem="activeItem"
        header="Admin2"
        link="/app/admin2"
        iconName="flaticon-controls"
        index="admin2"
        isHeader
        id="Admin2"
      />
      <b-tooltip custom-class="tool_tip" target="Admin2" placement="left" triggers="hover">Admin2</b-tooltip>
     -->
    </ul>
  </nav>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from 'vuex';
import isScreen from '@/core/screenHelper';
import NavLink from './NavLink/NavLink';
import topmixin from '../../topmixin.js';

import Push from 'push.js';
import { isEnabled, getSound } from '@/utils/notificationPrefs';
import { canUseConversations } from '@/utils/siteCapability';

export default {
  name: 'Sidebar',
  components: { NavLink },
  mixins: [topmixin],
  data() {
    return {
      temp: false,
      forceReactivity: 0 // Add this to force computed property updates
    };
  },

  created() {
    this.setActiveByRoute();
    // NOTE: Browser notification permission is now prompted via a user-gesture
    // banner in Layout.vue (modern browsers require a click to reliably show
    // the permission dialog). No silent auto-request here.
  },

  mounted() {
    if(localStorage.getItem('newConversationAvailable'))
      this.newConversationAvailable = localStorage.getItem('newConversationAvailable') === 'true' ? true : false;
  },

  methods: {
    ...mapActions('layout', ['changeSidebarActive', 'switchSidebar']),

    onGranted() {
      
    },

    onDenied() {
      // Push notification permission denied
    },

    setActiveByRoute() {
      const paths = this.$route.fullPath.split('/');
      paths.pop();
      this.changeSidebarActive(paths.join('/'));
    },
    sidebarMouseEnter() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(false);
        this.setActiveByRoute();
      }
    },
    sidebarMouseLeave() {
      if (!this.sidebarStatic && (isScreen('lg') || isScreen('xl'))) {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      }
    },
    elementExists(id) {
      return !!document.getElementById(id);
    },
  },
  
  computed: {
    ...mapState({
        sidebarStatic: state => state.layout.sidebarStatic,
        sidebarOpened: state => !state.layout.sidebarClose,
        activeItem: state => state.layout.sidebarActiveElement,
        newChatMessagesAvailable: state => state.chat.newChatMessagesAvailable,
        newChatMessageTimestamp: state => state.chat.newChatMessageTimestamp,
        latestUnreadMessage: state => state.chat.latestUnreadMessage,
        // V2 Conversations (V1 removed)
        conversationsV2Rooms: state => state.conversationsV2.rooms,
        newConversationMsgTimestamp: state => state.conversationsV2.newConversationMsgTimestamp,
        latestInboundMessage: state => state.conversationsV2.latestInboundMessage,
        // Kanban @-mention notifications (cleared via bell-icon "Mark all read")
        notificationsList: state => state.notifications.notifications,
    }),

    // Kanban green-dot: any unread type='KANBAN' notification for the current user.
    hasKanbanUnread() {
      const list = this.notificationsList;
      if (!Array.isArray(list)) return false;
      return list.some(n => n && n.type === 'KANBAN');
    },
    
    // Computed property to replace V1 newConversationMsgAvailable
    newConversationMsgAvailable() {
      // Force reactivity by referencing a data property that changes
      // eslint-disable-next-line no-unused-vars
      const _ = this.forceReactivity;

      // Check settings using multiple approaches to handle timing issues
      const customerState = this.$store.state.customer;
      const allSettings = customerState?.allSettings;
      const settingsArray = customerState?.settings;

      // Per-site SMS capability — see src/utils/siteCapability.js (single implementation).
      // Both sources are consulted because allSettings is not always populated.
      // NOTE: this previously tested `!!PropertyValue` (truthy-only), so a whitespace-only
      // number would have read as ENABLED here while trim-aware surfaces read DISABLED.
      // No prod site is in that state today (all 18 disabled sites hold a true ''), so this
      // is a no-op on current data — it just stops the two from ever diverging.
      // canUseConversations (number OR WhatsApp), matching the nav rule in config/ability.js.
      if (!canUseConversations(allSettings) && !canUseConversations(settingsArray)) {
        return false;
      }

      if (this.conversationsV2Rooms && Array.isArray(this.conversationsV2Rooms)) {
        // Show indicator if ANY room has unread messages (unreadCount > 0)
        const unreadRooms = this.conversationsV2Rooms.filter(room => {
          const unreadCount = parseInt(room.unreadCount) || 0;
          return unreadCount > 0;
        });

        return unreadRooms.length > 0;
      }

      return false;
    }
  },

  watch: {
      newChatMessagesAvailable(newValue, oldValue) {
        const link = document.querySelector("[rel='icon']");
        if(newValue) {
          document.title = '👀 Teamio - New Chat Message!';
          link.setAttribute('href','/alert.ico');
        } else {
          document.title = 'Teamio.app';
          link.setAttribute('href','favicon.ico');
        }
      },

      // Fires every time a new chat message snapshot arrives (not just on boolean flip).
      // Gated on CHAT_NOTIFICATIONS_SOUND_PUSH_ENABLED (defaults ON). Sound file from CHAT_NOTIFICATIONS_SOUND.
      newChatMessageTimestamp(newValue) {
        if (newValue > 0) {
          const userID = this.$store.state.customer?.userID;
          if (!isEnabled(userID, 'chat')) return;
          const finalSound = getSound(userID, 'chat');
          this.$parent.playSound('/sounds/' + finalSound);
          const msg = this.latestUnreadMessage;
          try {
            if (msg && msg.senderName) {
              const preview = msg.content.length > 50 ? msg.content.substring(0, 50) + '...' : msg.content;
              Push.create(msg.senderName, { body: preview, timeout: 6000 });
            } else {
              Push.create("New Teamio Chat Message Available!", { timeout: 6000 });
            }
          } catch (e) { /* Push may throw if permission denied; ignore */ }
        }
      },

      // Fires every time a new inbound SMS message arrives (mirrors chat pattern).
      // Gated on SMS_NOTIFICATIONS_SOUND_PUSH_ENABLED. Sound file from SMS_NOTIFICATIONS_SOUND.
      newConversationMsgTimestamp(newValue) {
        if (newValue <= 0) return;
        const userID = this.$store.state.customer?.userID;
        if (!isEnabled(userID, 'sms')) return;

        // Debounce: backend writes the Firestore conversation doc in two
        // phases for a single inbound SMS — phase 1 advances tsNum but
        // lastMessage.content is still the previous message; phase 2
        // (~500ms later) updates content to the new message. Both fire
        // this watcher. Without debounce, the user gets two pushes —
        // the first with stale content. Coalesce to one fire with the
        // latest state by waiting for ~650ms of quiet.
        if (this._smsPushTimer) {
          clearTimeout(this._smsPushTimer);
        }
        this._smsPushTimer = setTimeout(() => {
          this._smsPushTimer = null;
          const finalSound = getSound(userID, 'sms');
          this.$parent.playSound('/sounds/' + finalSound);
          const msg = this.latestInboundMessage;
          try {
            if (msg && msg.roomName) {
              const preview = (msg.content || '').length > 50
                ? msg.content.substring(0, 50) + '...'
                : (msg.content || '');
              Push.create(`SMS from ${msg.roomName}`, { body: preview, timeout: 6000 });
            } else {
              Push.create('New Teamio SMS Message!', { timeout: 6000 });
            }
          } catch (e) { /* Push may throw if permission denied; ignore */ }
        }, 650);
      },

      // Watch for settings changes to re-evaluate indicator
      '$store.state.customer.settings': {
        handler(newSettings, oldSettings) {
          if (newSettings && newSettings.length > 0 && (!oldSettings || oldSettings.length === 0)) {
            this.forceReactivity = Date.now() % 1000;
          }
        },
        deep: true
      },

      '$store.state.customer.allSettings': {
        handler(newAllSettings, oldAllSettings) {
          if (newAllSettings && !oldAllSettings) {
            this.forceReactivity = Date.now() % 1000;
          }
        },
        deep: true
      },

      // Watch for changes in conversations rooms
      conversationsV2Rooms: {
        handler(newVal, oldVal) {
          try {
            // Force computed property re-evaluation by changing data property
            this.forceReactivity = Date.now() % 1000;
          } catch(e) {
            console.error('[Sidebar] Error in rooms watcher:', e);
          }
        },
        deep: true,
        immediate: true
      },

      // Watch for conversation notifications like chat notifications
      newConversationMsgAvailable(newValue, oldValue) {
        const link = document.querySelector("[rel='icon']");

        // Only update document title/icon if chat notifications aren't already active
        // This prevents conversations from overriding chat notifications
        if (!this.newChatMessagesAvailable) {
          if (newValue) {
            // Don't override if document title already shows chat notifications
            if (!document.title.includes('Chat Message')) {
              document.title = '📱 Teamio - New SMS Messages!';
              link.setAttribute('href', '/alert.ico');
            }
          } else {
            // Only reset if no chat notifications are active
            document.title = 'Teamio.app';
            link.setAttribute('href', '/favicon.ico');
          }
        }
      }
  }
};
</script>

<!-- Sidebar styles should be scoped -->
<style lang="scss">
.tool_tip{
  width: 150px;
  position: absolute !important;
 left: 200px !important;
 //left:-10px !important;
}



</style>
<style src="./Sidebar.scss" lang="scss" scoped/>